/**
 * Layout Section Component
 *
 * A reusable layout component that provides consistent padding and max-width
 * for content sections throughout the application.
 */
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface LayoutSectionProps {
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export function LayoutSection({ children, className = '', fullWidth = false }: LayoutSectionProps) {
  return (
    <section
      className={cn(
        'w-full py-6 px-4 sm:px-6 md:px-8',
        !fullWidth && 'max-w-7xl mx-auto',
        className
      )}
    >
      {children}
    </section>
  );
}
